var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card-content",
    [
      _c("w-input", {
        attrs: { fancy: "", label: _vm.$ct("labels.title") },
        nativeOn: {
          keydown: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
            )
              return null
            $event.preventDefault()
            return _vm.focusEditor.apply(null, arguments)
          },
        },
        model: {
          value: _vm.title,
          callback: function ($$v) {
            _vm.title = $$v
          },
          expression: "title",
        },
      }),
      _c("w-editor", {
        ref: "editor",
        staticClass: "mt",
        attrs: {
          value: _vm.text,
          fancy: "",
          label: _vm.$ct("labels.description"),
          height: "400",
        },
        on: {
          input: function ($event) {
            return _vm.onInput($event)
          },
          "cursor-position": function ($event) {
            return _vm.$emit("cursor-position", $event)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }